import { Store, Module, ActionContext, MutationTree } from 'vuex'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface DashboardState {
    figures: any;
    widgets: Array<any>;
    sales: Array<any>;
    figures2: Array<any>;
    period: number;
    loading: boolean;
    
}
class DashboardModule implements Module<DashboardState, any>{
    namespaced = true;
    state={
        figures: [],
        widgets: [],
        sales: [],
        figures2: [],
        period: parseInt(Util.abp.clock.today().substr(0, 4)),
        loading:false,
    }
    actions = {
        async getDashFigures(context: ActionContext<DashboardState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/dash-figures', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return false;
            });
            if (reponse) {
                context.state.loading = false;
                context.state.figures = (reponse as any).data.result;
                return true;
            } else
                return false;
        },        
        async getWidgetValues(context: ActionContext<DashboardState, any>, payload: any) {
            let reponse = await Ajax.get('/api/dash-widgets', { params: payload.data }).catch(e => {
                return false;
            });
            if (reponse) {
                context.state.widgets = (reponse as any).data.result;
                return context.state.widgets;
            } else
                return false;
        },
        async getWidgetSales(context: ActionContext<DashboardState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/widget-sales', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return false;
            });
            context.state.loading = false;
            if (reponse) {
                context.state.sales = (reponse as any).data.result;
                return context.state.sales;
            } else
                return false;
        },
        async getWidgetFigures(context: ActionContext<DashboardState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/widget-figures', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return false;
            });
            context.state.loading = false;
            if (reponse) {
                context.state.figures2 = (reponse as any).data.result;
                return context.state.figures2;
            } else
                return false;
        },
    };
    mutations = {
        setPeriod(state: DashboardState, period: number) {
            state.period = period;

        }, 
    };
}
const dashboardModule = new DashboardModule();
export default dashboardModule;